import React from "react";
import Banner from "../components/Banner";
import About from "../components/AboutComponent";
import Body from "../components/Body";
import "../App.scss";

const Home = () => {
  return (
    <>
      <Banner />
      <About />
      <Body />
    </>
  );
};

export default Home;
